import { render } from "./TransferTables.vue?vue&type=template&id=e1daf79c"
import script from "./TransferTables.vue?vue&type=script&lang=js"
export * from "./TransferTables.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__